import { PlainDate } from "./date"

export interface Rate {
	rate: number
	startDate: string
	endDate: string
}

export function getMileageRate(date: PlainDate, rates: readonly Rate[]): number {
	
	const rate = rates.find((r) => PlainDate.isBetween(date, r.startDate, r.endDate))
	if (!rate) {
		console.error("No rate defined for date", date)
		//TODO: what return value should be here?
		return 0
	}

	return rate.rate
}
